<template>
  <div class="advantage">
    <div class="advantage__inner">
      <div class="advantage__body">
        <h3 class="advantage__title">
          {{ getData(['text', 'title']) }}
        </h3>

        <div class="advantage__text">
          {{ getData(['text', 'subtitle']) }}
        </div>
      </div>

      <div class="advantage__img"
        :style="backImg"
      />
    </div>

    <a
      :href="href"
      class="advantage__link"
    >
      {{ linkText }}
    </a>
  </div>
</template>

<script>
import objectPath from 'object-path';

export default {
  name: 'advantage',

  inject: ['adaptive'],

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    backImg() {
      const img = this.getData(['body', 'svg']);

      return `background-image: url(${img})`;
    },
    link() {
      return this.getData(['links', 0]);
    },
    href() {
      return this.link?.url
    },
    linkText() {
      return this.link?.text;
    }
  },

  methods: {
    getData(path = []) {
      const key = this.adaptive.isMobile ? 'mobile' : 'desktop';

      return objectPath.get(this.data.content?.[key], path);
    },
  }
}
</script>

<style lang="scss">
  .advantage {
    border: 1px solid $gray_lu2;
    padding: 16px;
    display: flex;
    flex-direction: column;

    @include breakpoint("desktop") {
      padding: 24px;
    }

    &__inner {
      display: flex;
      justify-content: space-between;

      @include breakpoint("desktop") {
        flex-direction: column;
      }
    }

    &__title {
      font-family: Gilroy, sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 8px;
      margin-top: 0;

      @include breakpoint("desktop") {
        font-family: VAGRounded, sans-serif;
        font-size: 32px;
        font-weight: 300;
        line-height: 40px;
      }
    }

    &__text {
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;

      @include breakpoint("desktop") {
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__link {
      color: $blue;
      font-size: 14px;
      line-height: 16px;
      font-weight: 600;
      margin-top: auto;

      @include breakpoint("desktop") {
        font-size: 20px;
        line-height: 28px;
      }
    }

    &__img {
      width: 56px;
      height: 56px;
      background-color: $blue;
      border-radius: 4px;
      background-position: 50%;
      background-repeat: no-repeat;
      flex: 0 0 auto;
      margin-left: 16px;

      @include breakpoint("desktop") {
        margin-bottom: 20px;
        width: 80px;
        height: 80px;
        margin-left: 0;
      }
    }

    &__body {
      @include breakpoint("desktop") {
        order: 1;
      }
    }
  }
</style>